import apiClient from "../api/apiClient"
import { AccountSummary, CashClose } from '../../types'

export interface LedgerEntry {
  _id: string
  company_id: string
  date: string
  description: string
  ref_type: string
  ref_id: string | null
  type: 'credit' | 'debit'
  account?: 'cash' | 'in_transit' | 'bank'
  bank_account_id?: string | null
  amount: number
  balance_after: number
  created_by: string
  createdAt: string
}

export interface LedgerListResponse {
  info: {
    page: number
    limit: number
    total: number
    totalPages: number
    hasNextPage: boolean
  }
  results: LedgerEntry[]
}

export const accountLedgerService = {
  async getEntries(params: { from?: string; to?: string; page?: number; limit?: number; account?: string; bank_account_id?: string }): Promise<LedgerListResponse> {
    const response = await apiClient.get<LedgerListResponse>('/admin/account-ledger', { params })
    return response.data
  },

  async getCurrentBalance(): Promise<number> {
    const response = await apiClient.get<{ balance: number }>('/admin/account-ledger/balance')
    return response.data.balance
  },

  async setOpeningBalance(amount: number): Promise<void> {
    await apiClient.post('/admin/account-ledger/opening-balance', { amount })
  },

  async getSummary(): Promise<AccountSummary> {
    const response = await apiClient.get<AccountSummary>('/admin/account-ledger/summary')
    return response.data
  },

  async getCloses(): Promise<CashClose[]> {
    const response = await apiClient.get<{ results: CashClose[] }>('/admin/account-ledger/closes')
    return response.data.results
  },

  async addBank(name: string): Promise<void> {
    await apiClient.post('/admin/account-ledger/banks', { name })
  },

  async reconcileOpening(data: { expected: number; cash: number; in_transit: number; banks: { bank_account_id: string; amount: number }[]; reason: string }): Promise<void> {
    await apiClient.post('/admin/account-ledger/reconcile-opening', data)
  },

  async closeDay(data: { expected: number; counted: number; retained: number; variance_reason: string }): Promise<void> {
    await apiClient.post('/admin/account-ledger/close', data)
  },

  async deposit(data: { allocations: { cash_close_id: string; amount: number }[]; bank_account_id: string; reference: string; deposited_at: string }): Promise<void> {
    await apiClient.post('/admin/account-ledger/deposits', data)
  },
}
